import React from "react";

const Presupuesta = () => {
  return (
    <div className="container my-5 text-center">
      <h1 className="mb-4">Solicita tu presupuesto</h1>
      <p>Haz clic en el botón de abajo para acceder al formulario de presupuesto.</p>
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSdhkxxeZGGt8nESj3hH9Yoi_wPFo1qaR-6RA_gSo6Cj2sADAQ/viewform?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary"
      >
        Ir al Formulario
      </a>
    </div>
  );
};

export default Presupuesta;